import { GridColTypeDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Box, Tooltip } from "@mui/material";

import baseColumn from "./BaseColumn";
import { fieldLabelFormat } from "../TableUtils";
import ISONumber from "components/formatting/ISONumber";
import AbbreviateNumber from "components/formatting/AbbreviateNumber";

export interface NumberOptions {
  format: Intl.NumberFormatOptions;
  headerLabels?: Record<string, string>;
}

function currencyColumn(options?: NumberOptions): GridColTypeDef {
  const currencyColumn: GridColTypeDef = {
    ...baseColumn,
    type: "string",
    renderCell: (params: GridRenderCellParams) => {
      const value = parseFloat(params.value)
      return (
        <Box>
          <AbbreviateNumber
            options={{
              style: "currency",
              ...options?.format
            }}
            value={params.formattedValue || 0} />
        </Box>
      );
    }
  };
  if (options?.headerLabels) {
    currencyColumn.renderHeader = fieldLabelFormat(options.headerLabels);
  }
  return currencyColumn;
}

export default currencyColumn;